import React from "react";

const LicenseTerms = ({ acceptTerms, termsAccepted }) => (
  <div>
    <h4 className="mb-1">
      <strong>LICENSE OF CREATOR CONTENT</strong>
    </h4>
    <div className="terms creator-terms">
      <p>
        This License of Creator Content (this <strong>“License”</strong>)
        applies to the license of Creator Content from the creator of such
        content (the <strong>“Creator”</strong>) to the entity wishing to
        license and exploit such Creator Content (the <strong>“Brand”</strong>)
        pursuant to the terms (1) in this License and (2) set between the
        parties through the functionality of the Vyrill influencer platform
        located at https://vyrill.com/ (the <strong>“Platform”</strong>
        ). Each of Creator and Brand may be referred to herein individually as{" "}
        <strong>“you”</strong> or a <strong>“party”</strong> or collectively as
        the <strong>“parties”</strong>.{" "}
      </p>
      <strong>
        <p>
          Please read this License carefully. By clicking “I Accept” when that
          option is available to you, you agree to be bound by the terms of this
          License and all terms incorporated by reference. If you do not agree
          to the terms of this License in its entirety, you may not use the
          Creator Content.
        </p>
        <p>
          Vyrill Inc. (“Vyrill”) is a party to this License solely as a
          facilitator between Creator and Brand, and shall have no
          responsibility or liability for any of Creator’s or Brand’s actions or
          inactions, whether relating to this License, use of the Platform, or
          otherwise.
        </p>
      </strong>
      <ol>
        <li>
          Defined Terms
          <ol>
            <li>
              <strong>“Creator Appearance”</strong> means Creator’s name, voice,
              photo, image, likeness, biographical material or any other
              indications of Creator’s appearance or personality.
            </li>
            <li>
              <strong>“Creator Content”</strong> means the specific content (1)
              created, posted, stored and shared through the Platform, including
              messages, text, photos, videos, other materials and Creator
              Appearance and (2) selected by Brand for licensing hereunder.
            </li>
            <li>
              <strong>“License Terms”</strong> means the duration of the license
              to Brand (the <strong>“Term”</strong>
              ), the territorial restrictions on the license to Brand, if any
              (the <strong>“Territory”</strong>
              ), the fee for the license (the <strong>“License Fee”</strong>
              ), the exclusive or non-exclusive nature of the license, and any
              other license terms or restrictions established by the parties
              through the Platform’s functionality.
            </li>
          </ol>
        </li>
        <li>License Fee; Appointment of Payment Processing Agent.</li>
        <p>
          {" "}
          In full consideration of the grant of rights and license hereunder, on
          final negotiation of the License Terms, Brand shall pay the Creator
          the License Fee in US Dollars, using Vyrill as a payment processing
          agent, through the functionality of the Platform (including via PayPal
          functionality). Each of Creator and Brand hereby appoint Vyrill as its
          payment processing agent for the limited purpose of receiving or
          making payments on Creator’s or Brand’s behalf. Brand will receive a
          receipt through the functionality of the Platform upon payment of the
          License Fee indicating that payment has been made on the applicable
          date. Vyrill’s obligation to remit funds collected by Vyrill on
          Creator’s behalf shall be limited to funds that Vyrill has actually
          received and that are not subject to reversal, and Vyrill shall have
          no obligation to pursue any collection action against Brand or any
          third party. Receipt of funds from Brand by Vyrill on Creator’s behalf
          in connection with this License of the Creator Content shall be deemed
          receipt of funds from Brand by Creator and will satisfy the
          obligations owed to Creator by Brand in the amount of the applicable
          payment by Brand, even if Viryll fails to remit such funds received
          from Brand, and each party will perform its respective obligations
          under this Agreement as if such funds were received. Each of Creator
          and Brand will pay such fees as established by Vyrill, if any, due and
          owing by such party to Vyrill through the functionality of the
          Platform.
        </p>
        <li>Grant of Rights.</li>
        <p>
          In consideration of the License Fee and the agreements made between
          the Creator and the Brand through the functionality of the Platform,
          Creator hereby grants to Brand and its successors, licensees, and
          assigns during the Term and subject to the other License Terms, the
          right and license throughout the Territory to (a) use the Creator
          Content in all formats and media in and in connection with any
          advertising and promotional activities of the Brand without credit to
          the Creator and (b) reproduce, distribute, display, publicly perform,
          exhibit, and otherwise exploit the Creator Content in advertising and
          promotional activities of the Brand. Notwithstanding the foregoing,
          Brand does not have any obligation to to produce, distribute, or
          otherwise exploit the Creator Content.
        </p>
        <li>Reservation of Rights.</li>
        <p>
          Creator owns and retains all right, title, and interest in and to the
          Creator Content, subject to the license granted in Section 3.
        </p>
        <li>Creator Obligations.</li>
        <p>
          After mutual agreement of this License through the functionality of
          the Platform and payment in full of the License Fee to Vyrill, Creator
          shall deliver or make available the Creator Content to Brand through
          the Platform.
        </p>
        <li>Permissions.</li>
        <p>
          Creator has obtained from all persons and entities who are, or whose
          trademark or other property is, identified, depicted, or otherwise
          referred to in the Creator Content, such written and signed licenses,
          permissions, waivers, releases, and consents (collectively,{" "}
          <strong>”Permissions”</strong> and each, individually, a{" "}
          <strong>”Permission”</strong>
          ), including those relating to publicity, privacy, and any
          intellectual property rights, as are, or reasonably may be expected to
          be, necessary for Brand to exercise its rights in the Creator Content
          as permitted by this License without incurring any payment or other
          obligation to, or otherwise violating any right of, any such person or
          entity.{" "}
        </p>
        <li>
          Representations and Warranties; Indemnification; Limitation of
          Liability.
          <ol>
            <li>
              Creator represents and warrants that (i) it has the right, power,
              and authority to grant the rights and licenses granted hereunder
              and is the sole owner of the Creator Content; (ii) Brand’s use of
              the Creator Content as permitted by this License will not violate
              or infringe any copyright, trademark, or other intellectual
              property, or any privacy, publicity, contract, or other
              third-party right; and (iii) no consents from, or payments to, any
              third party are required for or by Creator’s grant of rights to
              Brand hereunder or by Brand’s exercise of such rights.
            </li>
            <li>
              Brand will indemnify, defend, and hold harmless Creator from and
              against, any losses, damages, liabilities, deficiencies, claims,
              actions, judgments, settlements, interest, awards, penalties,
              fines, costs, or expenses of whatever kind (
              <strong>“Losses”</strong>
              ), including attorneys’ fees and the cost of enforcing any right
              to indemnification hereunder and the cost of pursuing any
              insurance providers, arising out of or in connection with any
              third-party claim, suit, action, or proceeding arising under US
              law resulting directly or indirectly from the Brand’s use of the
              Creator Content. Notwithstanding the foregoing, Brand will not
              indemnify Creator where such Losses arise out of a breach by
              Creator of its representations and warranties hereunder, failure
              to obtain Permissions, or violation or infringement of any
              copyright, trademark or other intellectual property, or any
              privacy, publicity, contract or other third-party right.
            </li>
            <li>
              NEITHER LICENSOR NOR PRODUCER WILL BE LIABLE UNDER OR IN
              CONNECTION WITH THIS LICENSE FOR INDIRECT, INCIDENTAL,
              CONSEQUENTIAL, LIQUIDATED, SPECIAL, OR EXEMPLARY DAMAGES OR
              PENALTIES, INCLUDING WITHOUT LIMITATION, LOSSES OF BUSINESS,
              REVENUE, OR ANTICIPATED PROFITS, REGARDLESS OF WHETHER SUCH DAMAGE
              WAS FORESEEABLE AND WHETHER SUCH PARTY HAS BEEN ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGES.
            </li>
          </ol>
        </li>
        <li>
          Standard Terms.
          <ol>
            <li>
              Creator may not terminate, rescind, revoke, or modify this
              License, in whole or in part. Creator hereby waives its right to
              injunctive and other equitable relief in the event of a dispute
              with Brand. Creator has no right to enjoin or interfere with the
              production, distribution, exploitation, advertising, or promotion
              of the Creator Content.{" "}
            </li>
            <li>
              No waiver by any party of any of the provisions hereof will be
              effective unless explicitly set forth in writing (including
              through the functionality of the Platform). No waiver by any party
              will operate or be construed as a waiver of any failure, breach,
              or default not expressly identified by such written waiver,
              whether of a similar or different character, and whether occurring
              before or after that waiver. No failure to exercise, or delay in
              exercising, any right, remedy, power, or privilege arising from
              this License will operate or be construed as a waiver thereof; nor
              will any single or partial exercise of any right, remedy, power,
              or privilege hereunder preclude any other or further exercise
              thereof or the exercise of any other right, remedy, power, or
              privilege.
            </li>
            <li>
              Brand may freely assign or otherwise transfer any of its rights
              and delegate any of its obligations under this License. Creator
              may not assign or otherwise transfer any of its rights or delegate
              any of its obligations under this License without the prior
              written consent of Brand. This License is binding on and inures to
              the benefit of the parties hereto and their respective permitted
              successors and assigns.
            </li>
            <li>
              This relationship between the parties is that of independent
              contractors. Nothing contained in this License will be construed
              as creating any agency, partnership, joint venture, or other form
              of joint enterprise, employment, or fiduciary relationship between
              the parties, and neither party shall have authority to contract
              for or bind the other party in any manner whatsoever.
            </li>
          </ol>
        </li>
      </ol>
    </div>
    <div className="text-center">
      <button type="button" className="btn btn-primary" onClick={acceptTerms}>
        {termsAccepted ? "Unaccept " : "Accept "}Licensing Terms and Conditions
      </button>
    </div>
  </div>
);

export default LicenseTerms;
